function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "apple-gradient"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A5A5A5",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6C6C6C",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.21 6.605c.546-.01 1.467.338 2.372.707 1.482.594 1.712.62 3.195.01.878-.358 1.772-.652 2.72-.749 1.455-.15 2.794.193 4.04.942.616.375 1.162.825 1.601 1.397.15.193.155.3-.07.45-2.488 1.638-3.382 4.909-2.087 7.617.605 1.263 1.563 2.179 2.816 2.784.198.096.23.182.155.385a16.036 16.036 0 0 1-2.709 4.796c-.283.343-.572.68-.894.996-.974.969-2.109 1.263-3.436.904-.578-.155-1.119-.412-1.68-.605-1.51-.524-2.95-.246-4.369.36a5.529 5.529 0 0 1-1.595.417c-.797.085-1.493-.188-2.093-.702-1.194-1.017-2.114-2.259-2.896-3.613C1.435 21.24.846 19.677.455 18.04c-.37-1.547-.525-3.11-.348-4.694.16-1.462.605-2.832 1.483-4.02C2.864 7.6 4.57 6.654 7.21 6.605zm3.758-.91c.075-1.948.985-3.436 2.532-4.566.797-.588 1.702-.92 2.67-1.097.21-.037.263.022.263.225.016 2.227-.905 3.982-2.682 5.278-.717.524-1.568.75-2.467.738-.241 0-.348-.064-.316-.315.01-.086 0-.177 0-.263z",
  className: "svg-mono",
  fill: "url(#apple-gradient)",
  fillRule: "evenodd"
});

var SvgLocalfilesDarwin = function SvgLocalfilesDarwin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocalfilesDarwin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/localfiles_darwin.b3fbd81e.svg";
export { ForwardRef as ReactComponent };